/**
 * Liquidity icon keys for NAVIGATION artifacts in the Enterprise side nav.
 * Keys must match `packages/liquidity/src/icons/index.ts` (same as CMT nav allowlist).
 */
import type { ComponentType, SVGProps } from 'react';
import {
  MARKETING_MESSAGE_ICON_REGISTRY,
  type CampaignIconKey,
  type NavigationArtifactIconKey,
} from '@/enterprise/features/homepage/homePageBanner/MarketingWidget/marketingMessageIconRegistry';

export const DEFAULT_NAVIGATION_ARTIFACT_ICON_KEY = 'BoxCheckDuotoneIcon' as const satisfies NavigationArtifactIconKey;

type LiquidityIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export function resolveNavigationArtifactIcon(iconKey: string | undefined): LiquidityIconComponent {
  if (iconKey && Object.hasOwn(MARKETING_MESSAGE_ICON_REGISTRY, iconKey)) {
    return MARKETING_MESSAGE_ICON_REGISTRY[iconKey as CampaignIconKey];
  }

  return MARKETING_MESSAGE_ICON_REGISTRY[DEFAULT_NAVIGATION_ARTIFACT_ICON_KEY];
}
